module.exports = __webpack_public_path__ + "static/media/TapToCheckIn14Sept2020.51815bdb.gif";